import { render, staticRenderFns } from "./AnnouncementsForms.vue?vue&type=template&id=22aa38d2&"
import script from "./AnnouncementsForms.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsForms.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsForms.vue?vue&type=style&index=0&id=22aa38d2&prod&lang=css&"
import style1 from "./AnnouncementsForms.vue?vue&type=style&index=1&id=22aa38d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports